<template>
  <div v-if="active">
    <div v-html="this.module.html"></div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      modules: state => state.config.modules,
    }),
    module() {
      return this.modules.iqitfreedeliverycount ? this.modules.iqitfreedeliverycount : null;
    },
    active() {
      return this.module && this.module.active;
    },
  },
};
</script>
